import React, { createContext, useContext, useState } from "react";

const ModeContext = createContext({ mode: "scroll", setMode: () => {} });

export function ModeProvider({ children }) {
    const [mode, setMode] = useState("scroll"); // 'scroll' | 'flipbook'
    return (
        <ModeContext.Provider value={{ mode, setMode }}>
            {children}
        </ModeContext.Provider>
    );
}

export const useMode = () => useContext(ModeContext);
